import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { GrDocumentTxt } from "react-icons/gr";

export default function ListarLogs() {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [missingUsers, setMissingUsers] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    const loadLogs = async () => {
      try {
        const logsSnapshot = await getDocs(collection(db, 'Log'));
        const logsData = logsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setLogs(logsData);
        setFilteredLogs(logsData);
      } catch (error) {
        console.error('Erro ao carregar logs:', error);
      }
      setLoadingLogs(false);
    };

    const loadUsers = async () => {
      try {
        const userSnapshot = await getDocs(collection(db, 'User'));
        const userData = await Promise.all(
          userSnapshot.docs.map(async (docSnapshot) => {
            const user = { id: docSnapshot.id, ...docSnapshot.data() };

            if (user.igreja) {
              const igrejaRef = doc(db, 'Igreja', user.igreja);
              const igrejaSnapshot = await getDoc(igrejaRef);
              user.igreja = igrejaSnapshot.exists() ? igrejaSnapshot.data().nome : 'N/A';
            }

            if (user.cargo) {
              const cargoRef = doc(db, 'Cargo', user.cargo);
              const cargoSnapshot = await getDoc(cargoRef);
              user.cargo = cargoSnapshot.exists() ? cargoSnapshot.data().nome : 'N/A';
            }

            return user;
          })
        );

        setUsers(userData);
      } catch (error) {
        console.error('Erro ao carregar usuários:', error);
      }
      setLoadingUsers(false);
    };

    loadLogs();
    loadUsers();
  }, []);

  useEffect(() => {
    const lowerCaseFilter = filter.toLowerCase();
    setFilteredLogs(
      logs.filter(log => log.action?.toLowerCase().includes(lowerCaseFilter))
    );
  }, [filter, logs]);

  useEffect(() => {
    if (!loadingLogs && !loadingUsers) {
      const usersWithoutLogin = users.filter(user =>
        !logs.some(log => log.action === 'Primeiro-Login' && log.userId === user.id)
      );
      setMissingUsers(usersWithoutLogin);
    }
  }, [logs, users, loadingLogs, loadingUsers]);

  const formatTimestamp = (timestamp) => {
    if (timestamp?.seconds) {
      const date = new Date(timestamp.seconds * 1000);
      return date.toLocaleString('pt-BR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    }
    return 'Data não disponível';
  };

  return (
    <div>
      <Header />
      <div className="content">
        <Title name="Listar Logs">
          <GrDocumentTxt size={25} />
        </Title>
        <div className="">
          <div className="filter-container">
            <label htmlFor="filter">Filtrar por Ação:</label>
            <input
              type="text"
              id="filter"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              placeholder="Digite a ação para filtrar"
            />
          </div>

          {loadingLogs ? (
            <p>Carregando logs...</p>
          ) : (
            <table className="logs-table">
              <thead>
                <tr>
                  <th>Ação</th>
                  <th>Usuário ID</th>
                  <th>Nome do Usuário</th>
                  <th>Data e Hora</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs.map((log) => (
                  <tr key={log.id}>
                    <td data-label="Ação">{log.action || 'Não especificado'}</td>
                    <td data-label="Usuário ID">{log.userId || 'Não disponível'}</td>
                    <td data-label="Nome do Usuário">{log.userName || 'Não disponível'}</td>
                    <td data-label="Data e Hora">{formatTimestamp(log.timestamp)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <h2>Usuários sem "Primeiro-Login"</h2>
          {loadingUsers ? (
            <p>Carregando usuários...</p>
          ) : (
            <table className="users-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Igreja</th>
                  <th>Cargo</th>
                </tr>
              </thead>
              <tbody>
                {missingUsers.map((user) => (
                  <tr key={user.id}>
                    <td data-label="Nome">{user.name || 'Não disponível'}</td>
                    <td data-label="Email">{user.email || 'Não disponível'}</td>
                    <td data-label="Igreja">{user.igreja || 'Não disponível'}</td>
                    <td data-label="Cargo">{user.cargo || 'Não disponível'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
